export const properties = {
  environment: "prod",
  serviceauthId: "changemajor-app",
  domain: "https://changemajor.apps.asu.edu",
  endpoint : "https://h8wh069y21.execute-api.us-west-2.amazonaws.com/prod/resources",
  degreesearchUrl: "https://webapp4.asu.edu/programs",
  wpcareyUrl: "https://sos.wpcarey.asu.edu/forms/changemajor",
  wpcareyMinorsUrl: "https://sos.wpcarey.asu.edu/forms/adddropminor",
  crmApiUrl: "https://crmapi-prod.apps.asu.edu/v1"
};
